import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
// ========== Sentry 暂时关闭（需要恢复时取消下方注释） ==========
// import * as Sentry from "@sentry/vue";
// import {
//   getReplayIntegrationOptions,
//   getTracePropagationTargets,
// } from "@/utils/sentryNetwork";

// // 获取当前环境
// function getCurrentEnv() {
//   const host = window.location.host;
//   switch (host) {
//     case 'workwx.liangbaba.com':
//       return 'production';
//     case 'preworkwx.liangbaba.com':
//       return 'pre';
//     case 'testworkwx.liangbaba.com':
//       return 'test';
//     case 'test2workwx.liangbaba.com':
//       return 'test2';
//     case 'test3workwx.liangbaba.com':
//       return 'test3';
//     default:
//       return import.meta.env.MODE || 'development';
//   }
// }

// function getSentryDSN(env) {
//   const defaultDSN = "https://d1a02e61bc94bda10233382f8ea0e582@sentry.liangbaba.com/3";
//   switch (env) {
//     case 'production':
//     case 'pre':
//     case 'test':
//     case 'test2':
//     case 'test3':
//     case 'development':
//     default:
//       return defaultDSN;
//   }
// }

// function getSampleRates(env) {
//   switch (env) {
//     case 'production':
//       return {
//         tracesSampleRate: 0.1,
//         replaysSessionSampleRate: 0.01,
//         replaysOnErrorSampleRate: 1.0,
//       };
//     case 'pre':
//       return {
//         tracesSampleRate: 0.5,
//         replaysSessionSampleRate: 0.1,
//         replaysOnErrorSampleRate: 1.0,
//       };
//     case 'test':
//     case 'test2':
//     case 'test3':
//       return {
//         tracesSampleRate: 1.0,
//         replaysSessionSampleRate: 0.1,
//         replaysOnErrorSampleRate: 1.0,
//       };
//     case 'development':
//       return {
//         tracesSampleRate: 1.0,
//         replaysSessionSampleRate: 1.0,
//         replaysOnErrorSampleRate: 1.0,
//       };
//     default:
//       return {
//         tracesSampleRate: 1.0,
//         replaysSessionSampleRate: 0.1,
//         replaysOnErrorSampleRate: 1.0,
//       };
//   }
// }

// const currentEnv = getCurrentEnv();
// const sentryDSN = getSentryDSN(currentEnv);
// const sampleRates = getSampleRates(currentEnv);
// const isDevelopment = currentEnv === 'development' || import.meta.env.MODE === 'development';

// const getRelease = () => {
//   if (import.meta.env.VITE_SENTRY_RELEASE) {
//     return import.meta.env.VITE_SENTRY_RELEASE;
//   }
//   const packageName = 'workwx';
//   const packageVersion = '1.0.0';
//   return `${packageName}@${packageVersion}-${currentEnv}`;
// };

// const release = getRelease();

// console.log('Sentry 环境配置:', {
//   env: currentEnv,
//   isDevelopment: isDevelopment,
//   dsn: isDevelopment ? 'disabled (开发模式)' : sentryDSN,
//   release: release,
//   sampleRates,
// });

// if (!isDevelopment) {
//   Sentry.init({
//     Vue,
//     dsn: sentryDSN,
//     environment: currentEnv,
//     release: release,
//     integrations: [
//       Sentry.browserTracingIntegration({ router }),
//       Sentry.replayIntegration(getReplayIntegrationOptions()),
//     ],
//     tracesSampleRate: sampleRates.tracesSampleRate,
//     tracePropagationTargets: getTracePropagationTargets(),
//     replaysSessionSampleRate: sampleRates.replaysSessionSampleRate,
//     replaysOnErrorSampleRate: sampleRates.replaysOnErrorSampleRate,
//     sendDefaultPii: true,
//     beforeSend(event, hint) {
//       const salesInfo = store.state.salesInfo || {};
//       const userId = salesInfo.userId;
//       const salesName = salesInfo.sysUserName || salesInfo.name;

//       if (userId) {
//         Sentry.setUser({
//           id: userId,
//           username: salesName,
//         });

//         event.tags = event.tags || {};
//         event.tags.salesmanId = userId;
//         event.tags.salesmanName = salesName;

//         event.extra = event.extra || {};
//         event.extra.salesInfo = {
//           userId: userId,
//           salesName: salesName,
//           sysUserId: salesInfo.sysUserId,
//           sysUserName: salesInfo.sysUserName,
//         };
//       }

//       return event;
//     },
//   });
// } else {
//   console.log('[Sentry] 开发模式：错误上报已禁用');
// }
console.log('[Sentry] 已暂时关闭');
// ========== Sentry 暂时关闭 END ==========
import load from '@/components/load/load.js'
Vue.prototype.$load = load
window.$load = load


import '@/api'
import './assets/js/vantImport'
import 'vant/lib/index.less'
import '@/assets/css/baseStyle.less';
import 'lib-flexible'
import { Dialog, Toast } from 'vant'
import ImagePreview from './utils/imagePreview'
import ComCard from './components/com/ComCard.vue'

import '@/utils/gpsLock'

Vue.component('ComCard', ComCard)

Vue.use(ImagePreview)

import './assets/css/index.css'
import './assets/css/common.less'

Vue.config.productionTip = false

import VConsole from 'vconsole'
import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'
import { isMiniProgram } from '@/utils/index.js'

// new VConsole() // 调试
try {
  if (location.href.indexOf('isFrontTest') >= 0) {
    new VConsole() // 调试
  }
} catch (error) {

}

router.beforeEach((to, from, next) => {
  next()
})
console.log('当前环境：',import.meta);

// ========== Sentry 用户信息 / errorHandler 上报（暂时关闭） ==========
// function updateSentryUser() {
//   if (isDevelopment) {
//     return;
//   }
//   if (!Sentry || typeof Sentry.setUser !== 'function') {
//     return;
//   }
//   const salesInfo = store.state.salesInfo || {};
//   const userId = salesInfo.userId;
//   const salesName = salesInfo.sysUserName || salesInfo.name;
//   if (userId) {
//     Sentry.setUser({
//       id: userId,
//       username: salesName,
//     });
//   }
// }

// if (!isDevelopment) {
//   store.watch(
//     (state) => state.salesInfo,
//     (newSalesInfo) => {
//       if (newSalesInfo && newSalesInfo.userId) {
//         updateSentryUser();
//       }
//     },
//     { deep: true, immediate: true }
//   );
// }

Vue.config.errorHandler = (error, instance, info) => {
  console.error('Vue Error:', error);
  console.error('Vue Error:', info);

  // // 开发环境不上报到 Sentry
  // if (isDevelopment) {
  //   return;
  // }
  // if (!Sentry || typeof Sentry.captureException !== 'function') {
  //   return;
  // }
  // const salesInfo = store.state.salesInfo || {};
  // const userId = salesInfo.userId;
  // const salesName = salesInfo.sysUserName || salesInfo.name;
  // if (userId && typeof Sentry.setUser === 'function') {
  //   Sentry.setUser({
  //     id: userId,
  //     username: salesName,
  //   });
  // }
  // const sentryError = new Error(
  //   `Vue 报错: ${error.message || error.msg || '未知错误'}`
  // );
  // sentryError.name = 'Vue Error';
  // Sentry.captureException(sentryError, {
  //   tags: {
  //     salesmanId: userId || 'unknown',
  //     salesmanName: salesName || 'unknown',
  //   },
  //   extra: {
  //     salesInfo: {
  //       userId: userId,
  //       salesName: salesName,
  //       sysUserId: salesInfo.sysUserId,
  //       sysUserName: salesInfo.sysUserName,
  //     },
  //   },
  //   contexts: {
  //     vue: {
  //       componentName: instance?.$options?.name || instance?.$options?.__name,
  //       propsData: instance?.$options?.propsData,
  //       lifecycleHook: info,
  //     },
  //   },
  // });
}
// ========== Sentry 暂时关闭 END ==========

Vue.use(VueTour)

/* eslint-disable no-new */
// 获取cdn图片
Vue.prototype.getImgUrl = function (url = 'no_img.svg') { return `https://library.liangbaba.com/images/service_station/${url}` }
Vue.prototype.setHideView = function (bl) {
  if (bl) {
    document.getElementsByTagName('body')[0].className = 'hide';
  } else {
    document.body.removeAttribute('class', 'hide')
  }
};
function lbbBp(events, data = {}, callBack) {
  const { sysUserName, userId, name } = store.state.salesInfo;
  // log("STORE.STATE", store.state, {
  //   wecom_staff_name: sysUserName || name,
  //   wecom_staff_id: userId,
  //   click_time: new Date().toLocaleString(),
  //   ...data
  // });
  if (userId) {
    $http.post('bp', {
      eventCode: events,
      paramsBody: {
        wecom_staff_name: sysUserName || name,
        wecom_staff_id: userId,
        click_time: new Date().toLocaleString(),
        ...data,
      },
    }, {
      headers: {
        source: 3
      }
    }).then(res => { callBack && callBack('ok') }).catch(err => { callBack && callBack('err') });
  }
}
window.lbbBp = lbbBp;
Vue.prototype.lbbBp = lbbBp;

import loadingDirective from './directives/loading.js'
import autoAlignDirective from './directives/autoAlign.js'

// 注册全局指令
Vue.directive('loading', loadingDirective) // 加载中指令
Vue.directive('auto-align', autoAlignDirective) // 自动左右对齐指令


let _this;

new Vue({
  el: '#app',
  router,
  store,
  // components: { App },
  // template: '<App/>',
  render: h => h(App),

  created() {
    _this = this;
  },
  async mounted() {
    // session 恢复的主体常缺 certificationType/custorType，挂载后补一次（此时 $http 已就绪）
    store.dispatch('fetchUserCertificationType')

    // 连续点击5次空白区域呼出vconsole（排除常见交互元素和UI库class）
    let blankClickCount = 0;
    let blankClickTimer = null;
    document.body.addEventListener('click', function (e) {
      // 排除常见交互元素
      const excludeTags = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'LABEL'];
      // 可根据实际情况添加 class 前缀排除
      const excludeClassPrefixes = ['van-', 'el-', 'ant-', 'btn', 'icon'];
      const target = e.target;

      // 判断是否为交互元素或有特定 class
      const isExcludedTag = excludeTags.includes(target.tagName);
      const isExcludedClass = Array.from(target.classList).some(cls =>
        excludeClassPrefixes.some(prefix => cls.startsWith(prefix))
      );

      if (!isExcludedTag && !isExcludedClass) {
        blankClickCount++;
        if (blankClickTimer) clearTimeout(blankClickTimer);
        blankClickTimer = setTimeout(() => {
          blankClickCount = 0;
        }, 800); // 800ms内连续点击
        if (blankClickCount >= 5) {
          new VConsole();
          blankClickCount = 0;
        }
      }
    });
    // 隐藏键盘
    // window.addEventListener('touchstart', () => { document.activeElement.blur() });
    // 失去焦点 ios页面不回滚问题
    // window.addEventListener('focusout', () => {
    //   var currentPosition =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   if (currentPosition != 0) {
    //     currentPosition = currentPosition;
    //   }
    //   document.body.scrollTop = currentPosition;
    //   document.documentElement.scrollTop = currentPosition;
    // });
    var u = navigator.userAgent;
    var flag;
    var myFunction;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isIOS) {
      // try {
      //   await setWxAagentConfig()
      // } catch (error) {

      // }
      document.body.addEventListener('focusin', () => {  //软键盘弹起事件
        flag = true;
        clearTimeout(myFunction);
      })
      document.body.addEventListener('focusout', () => { //软键盘关闭事件
        flag = false;
        if (!flag) {
          myFunction = setTimeout(function () {
            var currentPosition =
              document.documentElement.scrollTop || document.body.scrollTop;
            if (currentPosition != 0) {
              currentPosition = currentPosition;
            }
            document.body.scrollTop = currentPosition;
            document.documentElement.scrollTop = currentPosition;

          }, 200);
        } else {
          return
        }
      })
    } else {
      return
    }
  },
});

// v8.4.24 全局下单前确认用户收货地址是否合规方法
Vue.prototype.commonCheckAddress = function (addressItem) {
  if (addressItem && addressItem.addressName && addressItem.streetNumber && addressItem.detailAddress && addressItem.longitude && addressItem.latitude) {
    return true
  } else {
    Dialog.alert({
      title: '系统提示',
      message: '当前地址暂无详细地址/gps位置不精准，不可下单请补充后下单',
      confirmButtonText: "修改地址",
      theme: 'round-button',
      closeOnClickOverlay: true
    }).then(() => {
      this.$router.push({
        path: '/receiveInfo-address',
        query: {
          type: 1,
          redirect: encodeURIComponent(window.location.href)
        }
      })
    })
    return false
  }
}

// 9.1 全局申请提货前置拦截
Vue.prototype.commonInterceptApplyOrder = async function ({
  categoryId,
  contractId
}) {
  return new Promise(async (resolve) => {
    if (categoryId == 1) {
      try {
        const { code } = await $http.post('deliveryLimitCheck', {
          contractId
        }, {
          isShowLoading: true
        })
        if (code == 200) {
          resolve(true)
        } else {
          resolve(false)
        }
      } catch (error) {
        console.log(error);
        resolve(false)
      }
    } else {
      resolve(true)
    }
  })
}

// 公用判断白条是否已签署协议
Vue.prototype.$lbbCheckFinanceSign = async function (callback) {

  const checkSign = async (type) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { code, ret } = await $http.get('checkSignStatus', {
          params: {
            protocolType: type,
            userIdCode: store.state.userInfo.userIdStr
          }
        });
        if (code == 200) {
          if (ret == true) {
            resolve()
          } else {
            if (type == 2) {
              Dialog.confirm({
                message: '尊敬的客户您好，请完成《协议书》签署，否则无法使用剩余白条额度进行支付,请联系客户到粮巴巴公众号签署！',
                confirmButtonColor: '#17f',
                confirmButtonText: '我知道了',
                showCancelButton: false,
              })
            } else if (type == 3) {
              Dialog.confirm({
                message: '您的担保人未签署担保函，暂无法使用剩余白条额度进行支付',
                confirmButtonColor: '#17f',
                confirmButtonText: '我知道了',
                showCancelButton: false,
              })
            }
            reject({})
          }
        } else {
          reject({})
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  const loading = Toast.loading({
    message: '请稍候...',
    forbidClick: true,
  });
  try {
    await checkSign(2)
    await checkSign(3)
    loading.clear()
    callback && callback()
  } catch (error) {
    // loading.clear()
    console.log(error);
  }
}
